import gql from 'graphql-tag';
import { Appointment } from 'graphModels/appointment';

export const FETCH_APPOINTMENTS_IDS_AND_CURSOR = gql`
  query (
    $page: Int!,
    $perPage: Int,
    $textSearch: String,
    $sort: AppointmentSortItem,
    $filters: AppointmentFilters
  ) {
    patientAppointments (
      page: $page,
      perPage: $perPage,
      textSearch: $textSearch,
      sort: $sort,
      filters: $filters
    ) {
      totalCount
      edges {
        appointment {
          appointmentId
          status
        }
      }
    }
  }
`;

export const FETCH_APPOINTMENTS = gql`
  query (
    $page: Int!,
    $perPage: Int,
    $textSearch: String,
    $sort: AppointmentSortItem,
    $filters: AppointmentFilters
  ) {
    patientAppointments (
      page: $page,
      perPage: $perPage,
      textSearch: $textSearch,
      sort: $sort,
      filters: $filters
    ) {
      totalCount
      edges {
        appointment {
          allowedConversationTypes
          appointmentId
          externalId
          status
          completedTimestamp
          filePrerequisiteStatus
          consultationType
          subjects {
            description
            user {
              userId
              type
              profile {
                phoneNumber
                firstName
                lastName
                middleName
                avatar
                policyId
                externalId
                title
              }
            }
          }
          participants {
            userAvailability {
              status
            }
            participantType
            user {
              userId
              type
              profile {
                firstName
                middleName
                lastName
                title
                avatar
              }
            }
          }
          providerGroupSpecialty {
            id
            name
          }
          conversations {
            start
            end
            status
          }
          attachments {
            metaDataId
          }
          schedules {
            startTime
            endTime
            status
          }
          summaries {
            summaryId
            description
            referral
          }
          prescriptions {
            status
          }
          service {
            serviceId
            name
            config {
              providerAvailabilityEnabled
              customerAvailabilityEnabled
              queueEnforcementType
              queueType
            }
            filesPrerequisitesConfig {
              enabled
              attributes {
                minimumUploadedFiles
                notificationMessageEn
                notificationMessageHe
              }
            }
          }
          permissions {
            orgNodeId
            roleResources {
              resourceCode
              create
              read
              update
              delete
              assign
            }
          }
          group {
            groupId
            currentAppointmentId
            appointments {
              appointmentId
              status
              version
              groupPosition
            }
          }
          case {
            casePrerequisite {
              status
              errorMessage
            }
          }
          faceToFaceType
          homeVisit {
            location {
              type
              address
            }
            vehicle {
              id
              name
              description
              externalId
            }
          }
        }
      }
    }
  }
`;

export const FETCH_APPOINTMENTS_ESTIMATED_TIME = gql`
    query ($appointmentIds: [String!]!) {
        appointmentsEstimatedTimeToBeServed (appointmentIds: $appointmentIds) {
          appointmentId,
          estimatedTimestamp,
          displayMessage,
          displayStyle {
            color
          }
        }
    }
`;
